export default "__VITE_ASSET__Cxt4gWMr__";